
export class StateDimension {
  id: number;
  stateId: number;
  businessProcessId: number;
  name: string;
  displayName: string;
  version: number;
}

export class StateDimensionListResult {
  error: boolean;
  errorMessage: string;
  errorMessageDetails: string;
  result: Array<StateDimension>;
}
